/**
 * Whether the access JWT may live in sessionStorage (this tab only).
 *
 * rememberMe=false: yes — F5 restores the token from tab memory.
 * rememberMe=true: no — JWT stays in a JS variable; refresh uses HttpOnly cookie.
 *
 * Uses the explicit flag (form / Redux), not the rememberMe cookie, so login
 * is not affected by a leftover cookie from a previous session.
 */
export function shouldPersistAccessToken(rememberMeFlag) {
  return !Boolean(rememberMeFlag);
}

export function accessTokenPersistOptions(rememberMeFlag) {
  return { persistSession: shouldPersistAccessToken(rememberMeFlag) };
}
